import React, { useState } from 'react'
import "./Question_3.css"
import { Link ,useParams} from 'react-router-dom'
import Navbar from "../Navbar/Navbar"


const Question_3 = () => {
  const [female,setFemale] = useState("female")
  const [male,setMale] = useState("male")
  const { id } = useParams();        // "03"
  const ids = id.slice(5)
  
  const handleQuestion = (e)=>{
    
  }

  return (
    <div className='portal-kiga-question-3-main'>
      <Navbar/>
      <section className='portal-kiga-question-3-section'>
       <div className='portal-kiga-question-3-section-header'>
        <p>What is the participant's gender?</p>
       </div>
       <div className='portal-kiga-question-3-section-btn-yes'>
         <Link  onClick={handleQuestion}  to={`/portal/booking/classes/?ages=${ids}&gender=${female}`}>Female</Link>
       </div>
       <div className='portal-kiga-question-3-section-btn-no'>
         <Link to={`/portal/booking/classes/?ages=${ids}&gender=${male}`}>Male</Link>
       </div> 
      </section>
      <footer className='portal-kiga-question-3-footer'>

        <div className='portal-kiga-question-3-footer-close'>
         <div className='portal-kiga-question-3-footer-close-btn'>
          <Link to="/">X</Link>
         </div>
         <div className='portal-kiga-question-3-footer-close-title'>
          <p>Cancel</p>
         </div>
        </div>

        <div className='portal-kiga-question-3-footer-right'>
         <div className='portal-kiga-question-3-footer-right-btn'>
          <Link to="/">{'>'}</Link>
         </div>
         <div className='portal-kiga-question-3-footer-right-title'>
          <p>Next</p>
         </div>
        </div>

      </footer>
    </div>
  )
}

export default Question_3